{{address?.street}}
{{address?.houseNumber}}<span *ngIf="address?.apartmentNumber"> lok. {{address?.apartmentNumber}}</span><br>
{{address?.city}} {{address?.zipCode}}
<ng-container *ngIf="address?.state">
  <br/>
  <span>{{address.state.name}}</span>
</ng-container>
